<!--
 * @Description:护眼常识页面从小学那边迁移过来的
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-04-14 18:47:27
 * @LastEditors: liujinlei liujinlei@zhihuiliu.com
 * @LastEditTime: 2023-12-20 15:13:33
 -->
<template>
  <div class="conten-box"
       v-if="queryNum <= 0">
    <van-nav-bar class="header"
                 title="书本详情"
                 :border="false"
                 @click-left="goBanck">
      <template #left>
        <van-icon :name='require("@/assets/images/icon-back.png")'
                  size="22" />
      </template>
    </van-nav-bar>
    <div class="headerMsg">
      <div class="bookImg">
        <van-image error-icon="photo-o"
                   :src="book_info.cover_img_url" />
      </div>
      <div class="msgBox">
        <div class="top">
          <div class="title">{{ book_info.book_name }}</div>
          <div class="msg">浙江教育出版集团<br>浙江青云在线教育科技有限公司 出品</div>
          <!-- <div class="numbers"><span>{{studyNum}}</span>{{ studyNumType }}人阅读过此书</div> -->
        </div>
        <!-- <van-button :icon="require('@/assets/images/icon-detailPlaypng.png')"
          round
          type="primary">立即学习</van-button> -->
      </div>
      <div class="line van-hairline--bottom"></div>
    </div>
    <div class="content">
      <div class="title">
        书本信息
      </div>
      <div class="table">
        <div class="tr">
          <div class="name">书名</div>
          <div class="msg">{{ book_info.book_name }}</div>
        </div>
        <div class="tr">
          <div class="name">年级</div>
          <div class="msg">{{ book_info.grade }}</div>
        </div>
        <div class="tr">
          <div class="name">分类</div>
          <div class="msg">{{ typeArr[book_info.type] }}</div>
        </div>
        <div class="tr">
          <div class="name">页码</div>
          <div class="msg">{{ book_info.page_count }}</div>
        </div>
        <div class="tr">
          <div class="name">出版社</div>
          <div class="msg">{{ book_info.press_name }}</div>
        </div>
        <div class="tr">
          <div class="name">版次</div>
          <div class="msg">{{ book_info.edition_number }}</div>
        </div>
        <div class="tr">
          <div class="name"
               style="font-weight: 500;">ISBN</div>
          <div class="msg">{{ book_info.isbn }}</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <van-button class="showLearn"
                  round
                  type="primary"
                  @click="showLearn = true">听说训练</van-button>
    </div>
    <van-popup class="newContent"
               overlay-class="whiteBg"
               :style="{ width:'100%',height: '100%'}"
               v-model="showLearn"
               position="right">
      <div class="conten-box">
        <van-nav-bar class="header"
                     title="听说训练"
                     :border="false"
                     @click-left="showLearn = false">
          <template #left>
            <van-icon :name='require("@/assets/images/icon-back.png")'
                      size="22" />
          </template>
        </van-nav-bar>
        <div class="headerMsg">
          <div class="bookImg">
            <van-image error-icon="photo-o"
                       :src="book_info.book_cover_url" />
          </div>
          <div class="msgBox">
            <div class="top">
              <div class="title">{{ book_info.book_name }}</div>
              <!-- <div class="numbers"><span>{{studyNum}}</span>{{ studyNumType }}人已经学习</div> -->
            </div>
            <van-button :icon="require('@/assets/images/icon-detailPlaypng.png')"
                        round
                        type="primary"
                        @click="goStudy"
                        :class="record.study_id ? 'moreWidth':''">{{record.study_id ? '继续上次学习' : '立即学习'}}</van-button>
          </div>
        </div>
        <div class="listBox"
             v-if="treeList.length">
          <List :listData="treeList"
                :record="record"
                @goDetail="goDetailFun" />
          <van-divider>我是有底线的</van-divider>
        </div>
        <div class="listBox"
             v-else>
          <NoData text="暂无数据" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { HttpFactory, getArgs, iosOrAndroid } from '@/assets/js/common'
import rqParams from './rq.js'
import List from '@/components/zjEnglishComponents/List'
import NoData from '@/components/NoData/NoData'
export default {
  name: 'index',
  components: {
    List,
    NoData
  },
  data() {
    return {
      business_id: null,
      queryNum: 1,
      book_id: 0,
      showLearn: false,
      book_info: {},
      record: {},
      studyNum: 0,
      studyNumType: '',
      typeArr: {
        1: '教材',
        2: '教辅',
        3: '试卷',
        4: '图书'
      },
      treeList: []
    }
  },
  watch: {
    queryNum(val) {
      if (val <= 0) {
        const ua = navigator.userAgent.toLowerCase()
        if (iosOrAndroid() == 'ios') {
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          } else {
            this.$nextTick(() => {
              this.$toast({
                duration: 3000,
                message: 'iOS用户请使用微信扫码打开\n否则无法录音训练'
              })
            })
          }
        }
      }
    }
  },
  created() {
  },
  mounted() {
    const param = getArgs()
    this.book_id = param.book_id
    this.business_id = param.business_id || 100002
    if (this.book_id) {
      if (!param.enterFrom) {
        // 扫码进来的要提交书本以获得书本列表
        this.submitbookstudyrecord()
      }
      // if (param.showDetail) {
      //   this.showLearn = true
      // }
      this.showLearn = true
      this.getDataList()
    } else {
      location.replace('./zjEnglishLogin.html')
    }
    if (this.business_id !== 100002) {
      document.title = '教辅详情'
    } else {
      document.title = '浙教中学英语听说系统'
    }
  },
  methods: {
    goDetailFun(data) {
      HttpFactory.postUrl(
        rqParams.submitbookstudyrecord({
          book_id: this.book_id,
          type: data.parent.type + 1,
          business_id: 100002,
          study_type: 1,
          study_id: data.item.model_id,
          resource_id: data.parent.resource_id
        }),
        res => {
          // this.getDataList()
        }
      )
      HttpFactory.postUrl(
        rqParams.getmodelinfo({
          model_id: data.item.model_id
        }),
        res => {
          const paper_list = res.data.paper_list || []
          if (paper_list.length > 0) {
            // 进入试卷模式
            location.href =
              './zjEnglishPaperTest.html?title=' +
              data.parent.resource_name +
              '&book_id=' +
              this.book_id +
              '&type=' +
              data.parent.type +
              '&resource_id=' +
              data.parent.resource_id +
              '&model_id=' +
              data.item.model_id +
              `&business_id=${this.business_id}`
          } else {
            this.goqusDetailFun(res.data.question_list[0], data)
          }
        }
      )
    },
    goqusDetailFun(qus, data) {
      if (!qus) {
        setTimeout(() => {
          this.$toast('题目信息不正确')
        }, 800)
        return
      }
      if (qus.sub_model_id == 5) {
        location.href =
          './zjEnglishListeningQuestions.html?guid=' +
          qus.guid +
          '&title=' +
          data.parent.resource_name +
          '&book_id=' +
          this.book_id +
          '&type=' +
          data.parent.type +
          '&resource_id=' +
          data.parent.resource_id +
          '&model_id=' +
          data.item.model_id +
          `&business_id=${this.business_id}`
        return
      }
      if (qus.model_id === 11) {
        if (qus.sub_model_id == 1) {
          location.href =
            './zjEnglishAnalogFollowUpReading.html?guid=' +
            qus.guid +
            '&title=' +
            data.parent.resource_name +
            '&book_id=' +
            this.book_id +
            '&type=' +
            data.parent.type +
            '&resource_id=' +
            data.parent.resource_id +
            '&model_id=' +
            data.item.model_id +
            `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 2) {
          location.href =
            './zjEnglishOralExpression.html?guid=' +
            qus.guid +
            '&title=' +
            data.parent.resource_name +
            '&book_id=' +
            this.book_id +
            '&type=' +
            data.parent.type +
            '&resource_id=' +
            data.parent.resource_id +
            '&model_id=' +
            data.item.model_id +
            `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 3) {
          location.href =
            './zjEnglishOralAnswerQuestions.html?guid=' +
            qus.guid +
            '&title=' +
            data.parent.resource_name +
            '&book_id=' +
            this.book_id +
            '&type=' +
            data.parent.type +
            '&resource_id=' +
            data.parent.resource_id +
            '&model_id=' +
            data.item.model_id +
            `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 4) {
          location.href =
            './zjEnglishOralExpressionTraining.html?guid=' +
            qus.guid +
            '&title=' +
            data.parent.resource_name +
            '&book_id=' +
            this.book_id +
            '&type=' +
            data.parent.type +
            '&resource_id=' +
            data.parent.resource_id +
            '&model_id=' +
            data.item.model_id +
            `&business_id=${this.business_id}`
        }
      } else {
        setTimeout(() => {
          this.$toast('题目信息不正确')
        }, 800)
      }
    },
    goStudy() {
      if (!this.record.resource_id) {
        const nextList = this.deal(
          JSON.parse(JSON.stringify(this.treeList)),
          node => {
            return node.model_list.length > 0
          }
        )
        this.record.resource_id = nextList[0].resource_id
        this.record.study_id = nextList[0].model_list[0].model_id
      }
      const nextList = this.deal(
        JSON.parse(JSON.stringify(this.treeList)),
        node => {
          return node.resource_id == this.record.resource_id
        }
      )
      const nextArr = nextList[0].model_list
      let qus = null
      nextArr.forEach((el, index) => {
        if (el.model_id == this.record.study_id) {
          qus = {
            item: el,
            parent: nextList[0]
          }
        }
      })
      if (qus) {
        this.goDetailFun(qus)
      }
    },

    deal(nodes, predicate) {
      // 如果已经没有节点了，结束递归
      if (!(nodes && nodes.length)) {
        return []
      }
      const newChildren = []
      for (const node of nodes) {
        if (predicate(node)) {
          // 如果节点符合条件，直接加入新的节点集
          newChildren.push(node)
          node.children = this.deal(node.children_list, predicate)
        } else {
          // 如果当前节点不符合条件，递归过滤子节点，
          // 把符合条件的子节点提升上来，并入新节点集
          newChildren.push(...this.deal(node.children_list, predicate))
        }
      }
      return newChildren
    },
    submitbookstudyrecord() {
      HttpFactory.postUrl(
        rqParams.submitbookstudyrecord({
          book_id: this.book_id,
          business_id: 100002
        }),
        res => {}
      )
    },
    goBanck() {
      const url = './zjEnglishHome.html'
      location.replace(url)
    },
    login() {},

    getDataList(page) {
      HttpFactory.postUrl(
        rqParams.getlistenspeakinfov2({
          book_id: this.book_id,
          business_id: 100002
        }),
        res => {
          this.book_info = res.data.book_info
          this.studyNum = res.data.study_count || 0
          if (this.studyNum > 10000) {
            this.studyNum = (this.studyNum / 10000).toFixed(1)
            this.studyNumType = '万'
          }
          this.record = res.data.study_record || {}
          // this.record = {}
          this.treeList = res.data.catalog_list
          this.queryNum--
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.conten-box {
  height: 100%;
  font-family: PingFangSC-Medium, PingFang SC;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .headerMsg {
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    position: relative;

    .line {
      position: absolute;
      height: 1px;
      width: calc(100% - 30px);
      bottom: 0;

      &::after {
        border-color: #e1e3e5;
      }
    }

    .bookImg {
      width: 90px;
      height: 112px;
      box-shadow: 0px 3px 9px 0px rgba(59, 63, 81, 0.09);

      /deep/ .van-image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        overflow: hidden;

        .van-image__error {
          background-color: #e5e5e5;
        }
      }
    }

    .msgBox {
      display: flex;
      flex-direction: column;
      margin-left: 16px;
      justify-content: space-between;
      flex: 1;
      overflow: hidden;

      .top {
        .title {
          font-size: 16px;
          font-weight: bold;
          color: rgba(69, 70, 74, 1);
          line-height: 18px;
          margin-top: 7px;
          margin-bottom: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .msg {
          font-size: 13px;
          font-weight: 400;
          color: rgba(164, 167, 176, 1);
        }

        .numbers {
          font-size: 13px;
          font-weight: 400;
          color: #45464a;
          margin-top: 20px;

          span {
            font-size: 18px;
            font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
            font-weight: normal;
            color: rgba(69, 70, 74, 1);
          }
        }
      }

      /deep/ .van-button {
        height: 25px;
        width: 86px;

        &.moreWidth {
          width: 122px;
        }

        background: rgba(69, 213, 133, 1);
        border-color: transparent;
        font-size: 12px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        padding: 0;
      }
    }
  }

  .content {
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
    padding: 20px 15px;
    box-sizing: border-box;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: rgba(69, 70, 74, 1);
      line-height: 18px;
      margin-bottom: 15px;
    }

    .table {
      .tr {
        display: flex;
        align-items: center;
        height: 40px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(225, 227, 229, 1);
        border-bottom: 0;

        &:last-child {
          border: 1px solid rgba(225, 227, 229, 1);
        }

        .name {
          width: 80px;
          padding-left: 13px;
          box-sizing: border-box;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: rgba(69, 70, 74, 1);
          border-right: 1px solid rgba(225, 227, 229, 1);
          height: 40px;
          line-height: 40px;
        }

        .msg {
          padding-left: 16px;
          box-sizing: border-box;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          font-weight: 400;
          color: rgba(116, 118, 125, 1);
          line-height: 40px;
        }
      }
    }
  }

  .footer {
    height: 70px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 10px 0px rgba(6, 11, 41, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;

    .showLearn {
      width: 300px;
      height: 40px;
      background: #45d585;
      border-color: transparent;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .newContent {
    .numbers {
      margin-top: 0 !important;
      color: #a4a7b0 !important;

      span {
        color: #a4a7b0 !important;
      }
    }

    .listBox {
      flex: 1;
      overflow: hidden;
      overflow-y: auto;
      padding: 0 15px;
    }
  }
}
</style>
